import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import { MarketingConsentStatus } from "../customer";
import { MarketingSuppressionReason } from "./marketing-suppression/marketing-suppression-zod-schema";

export const audienceMemberSchema = z.object({
  name: z.string(),
  customerId: zExt.objectId(),
  email: z.string().optional(),
  phoneNumber: z.string().optional(),
  emailSubscriptionStatus: z.enum(MarketingConsentStatus),
  emailSuppressionReasons: z.array(z.enum(MarketingSuppressionReason)),
  smsSubscriptionStatus: z.enum(MarketingConsentStatus),
  smsSuppressionReasons: z.array(z.enum(MarketingSuppressionReason)),
});

export type AudienceMember = z.infer<typeof audienceMemberSchema>;
